import Backbone from 'backbone';
import Cookies from 'js-cookie';
import { locale } from '../others/Configuration';
import Basket from '../models/Basket';
import $ from 'jquery';
import SharedDispatcher from '../others/SharedDispatcher';

export default class extends Backbone.View {
  /**
   * Constructor
   */
  initialize(options) {
    this.isRendered = false;
    this.itemsCount = $('.js-BasketList-item').length;
    this.itemsPerPage = 3;
    this.model = new Basket();
    this.pageIndex = options.pageIndex;

    this.$item = null;

    this.listenTo(this.model, 'change', this.render);
    this.formatPrices();
    this.render();
  }

  get events() {
    return {
      'click .js-BasketList-decrease': 'decreaseQuantity',
      'click .js-BasketList-increase': 'increaseQuantity',
      'click .js-BasketList-delete': 'removeItem',
      'click .js-Basket-previousPage': 'goToPreviousPage',
      'click .js-Basket-nextPage': 'goToNextPage',
      'click .js-Basket-oneclick': 'oneclick',
    };
  }

  oneclick(e) {
    // Do nothing, it's already a link
  }

  getPageIndexMax() {
    return Math.ceil(this.itemsCount / this.itemsPerPage) - 1;
  }

  isFirstPage() {
    return this.pageIndex === 0;
  }

  isLastPage() {
    return this.pageIndex === this.getPageIndexMax();
  }

  goToPage(pageIndex) {
    if ((pageIndex < this.pageIndex && this.isFirstPage()) || (pageIndex > this.pageIndex && this.isLastPage())) {
      return;
    }

    this.pageIndex = pageIndex;

    this.render();

    // We update the page index in the parent view (to store it even when this view is destroyed)
    SharedDispatcher.trigger('headerTabBasketView:updatePageIndex', { pageIndex: pageIndex });
  }

  goToPreviousPage() {
    this.goToPage(this.pageIndex - 1);
  }

  goToNextPage() {
    this.goToPage(this.pageIndex + 1);
  }

  decreaseQuantity(event) {
    this.updateQuantity(event, -1);
  }

  increaseQuantity(event) {
    this.updateQuantity(event, 1);
  }

  dispose() {
    this.remove();
    this.off();
  }

  /**
   * Update the quantity of a basket item and refresh the basket view
   *
   * @param {object}  event
   * @param {integer} quantityDifference
   */
  updateQuantity(event, quantityDifference) {
    var $item = $(event.target).closest('.js-BasketList-item'),
      $nextItem = $item.next(),
      itemNewQuantity = parseInt($item.find('.js-BasketList-quantity').val()) + quantityDifference;

    // If the new quantity is lower than 1, let"s delete this item
    if (itemNewQuantity <= 0) {
      this.removeItem(event);
      return;
    }

    // If we reached the maximum quantity allowed for this item
    if (itemNewQuantity > $item.data('quantityMax')) {
      return;
    }

    this.model.set({
      productId: $item.data('productId').toString(),
      offerId: $item.data('offerId'),
      masterProductId: $item.data('masterProductId').toString(),
      quantityDifference: quantityDifference,
    });

    this.model.fetch({
      action: 'update',
      dataType: 'html',
    });
  }

  /**
   * Delete an item from the basket and refresh the basket view
   *
   * @param {object} event
   */
  removeItem(event) {
    var $item = $(event.target).closest('.js-BasketList-item');

    this.model.set({
      productId: $item.data('productId').toString(),
      offerId: $item.data('offerId'),
      masterProductId: $item.data('masterProductId').toString(),
    });

    this.model.fetch({
      action: 'remove',
      dataType: 'html',
    });
  }

  formatPrices() {
    this.$el.find('[data-behavior-price=true]').each(function (i, item) {
      var format = '{0}';
      var priceDefaultFormat = $(item).text().indexOf(',') === -1 ? false : true;

      if ($(this).data('behavior-price-format')) {
        format = $(this).data('behavior-price-format');
      }

      var index = priceDefaultFormat ? $(item).text().indexOf(',') : $(item).text().indexOf('€');

      if (index > 0) {
        var cents =
          $(item)
            .text()
            .substring(index + 1) !== ''
            ? $(item)
                .text()
                .substring(index + 1)
            : '';
        var price = $(item).text().substring(0, index) + '<sup>€' + cents + '</sup>';
        var PayWord = format.replace(' {0}', '');
        price = price.replace(' €', '').replace(PayWord, '');
        var str = format.replace('{0}', price);
        $(item).html(str);
      }
    });

    var $TotalPrice = $('.js-LayerBasket__total-price');
    if ($TotalPrice.length && locale === 'fr-BE' && $TotalPrice.text().indexOf(',') !== -1) {
      $TotalPrice.text($TotalPrice.text().replace('€', '').replace(',', '€'));
    }
  }

  /**
   * Render the view
   */
  render() {
    if (!this.isRendered && this.pageIndex > this.getPageIndexMax()) {
      this.goToPage(this.getPageIndexMax());
      return;
    }

    $('.js-BasketList-item').addClass('hidden');
    for (var index = 0; index < this.itemsPerPage; index++) {
      this.$('.js-BasketList-item')
        .eq(this.itemsPerPage * this.pageIndex + index)
        .removeClass('hidden');
    }

    this.$('.js-Basket-previousPage').attr('disabled', this.isFirstPage());
    this.$('.js-Basket-nextPage').attr('disabled', this.isLastPage());

    if (this.isRendered && !this.model.get('state')) {
      return;
    }

    if (this.isRendered && this.model.get('state')) {
      SharedDispatcher.trigger('headerTabBasketView:refresh');

      if (this.model.get('state')) {
        this.model.unset('state', { silent: true });
      }
    } else {
      this.isRendered = true;
    }

    this.renderCartCounter();
  }

  /**
   * Update the rendering of the cart counter
   */
  renderCartCounter() {
    // We update the basket items counter
    var count = Cookies.get('NBART');
    if (count) {
      SharedDispatcher.trigger('cartcount:update', { count: count });
    }
  }
}
